export const Default_CODE =
  "84e1a5936fe23d544abc4c020703320f96dff20f0398b4332fc328c0a5cd789aa80406c6a280aebccfc4fe50bd9fa50e";
